import { useParams } from "react-router-dom";
import { SmsCampaignContentForm } from "../../../../../components/secondaryComponents/SmsCampaign";
import { useGetSmsCampaignDetails } from "../../../../../hooks/api/queries/useMarketing";
import secondaryComponents from "../../../../../components/secondaryComponents";

const SmsCampaignContent = () => {
  const { id } = useParams();
  const { data: smsCampaign, isLoading } = useGetSmsCampaignDetails({ id });

  return (
    <section>
      <secondaryComponents.LoaderHelper
        classNames={"mt-5"}
        isLoading={isLoading}
      >
        <SmsCampaignContentForm smsCampaign={smsCampaign} />
      </secondaryComponents.LoaderHelper>
    </section>
  );
};

export default SmsCampaignContent;
